export default __webpack_public_path__ + "static/media/pp.c298effd.jpg";